'use strict';

(function () {
  'use strict';

  angular.module('vnext').component('msSleepPlan', {
    templateUrl: 'sleep/templates/sleep-plan-component.html',
    controller: 'SleepPlanCtrl',
    controllerAs: 'vm'
  });
})();